import "../styles/hearing.css";

import ear from "../assets/images/ear.png";
import hearingBg from "../assets/images/ser6.png";

function Hearing() {
  return (
    <>

      {/* ================= Hero ================= */}

      <section
        className="hearing-hero" data-aos="fade-up"
        style={{ backgroundImage: `url(${hearingBg})` }}
      >
        <div className="hearing-overlay">

          <div className="hero-content">

            <h1>Firstly, Understand How Do We Hear?</h1>

            <p>
              Our ears work together with the brain to convert sound waves
              into meaningful sounds that help us communicate with the world.
            </p>

          </div>

        </div>
      </section>

      {/* ================= Ear Anatomy ================= */}

      <section className="ear-section">

        <div className="ear-image" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="0">

          <img src={ear} alt="Ear Anatomy" />

        </div>

        <div className="ear-content">

          <h2>How Hearing Works</h2>

          <p>
            Hearing begins when sound waves travel through the outer ear
            and reach the eardrum.
          </p>

          <p>
            The vibrations are amplified by three tiny bones inside
            the middle ear before reaching the cochlea.
          </p>

          <p>
            The cochlea converts these vibrations into electrical signals,
            which are sent to the brain through the auditory nerve.
          </p>

          <p>
            Finally, the brain interprets these signals as the sounds
            we hear every day.
          </p>

        </div>

      </section>
            {/* ================= Banner ================= */}

      <section className="hearing-banner">

        <div className="banner-left">
          <h2>Jagadish Hearing Aids</h2>
        </div>

        <div className="banner-right">
          <p>
            "We hear not only with our ears, but with our hearts."
          </p>
        </div>

      </section>

      {/* ================= Process ================= */}

      <section className="process-section">

        <div className="process-heading">

          <h2>How We Hear</h2>

          <p>
            Our ability to hear involves a remarkable process that transforms
            sound waves into electrical signals interpreted by the brain.
          </p>

        </div>

        <div className="process-grid">

          <div className="process-card" data-aos="fade-up" data-aos-duration="900" data-aos-delay="0">

            <span>01</span>

            <h3>Sound Collection</h3>

            <p>
              The outer ear collects sound waves and directs them through the
              ear canal toward the eardrum.
            </p>

          </div>

          <div className="process-card" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">

            <span>02</span>

            <h3>Sound Amplification</h3>

            <p>
              The eardrum vibrates, causing the tiny middle ear bones to
              amplify the sound vibrations.
            </p>

          </div>

          <div className="process-card" data-aos="fade-up" data-aos-duration="900" data-aos-delay="300">

            <span>03</span>

            <h3>Signal Conversion</h3>

            <p>
              The cochlea converts sound vibrations into electrical impulses
              using thousands of microscopic hair cells.
            </p>

          </div>

          <div className="process-card" data-aos="fade-up" data-aos-duration="900" data-aos-delay="450">

            <span>04</span>

            <h3>Brain Interpretation</h3>

            <p>
              The auditory nerve carries electrical signals to the brain,
              where they are recognized as meaningful sounds.
            </p>

          </div>

        </div>

      </section>

            {/* ================= Hearing Loss Symptoms ================= */}

      <section className="symptoms-section">

        <div className="symptoms-heading">

          <h2>Hearing Loss Symptoms</h2>

          <p>Are you experiencing...</p>

        </div>

        <div className="symptoms-card" data-aos="fade-up">

          <div className="symptom-item">
            <span>✓</span>
            <p>Frequently asking people to repeat themselves</p>
          </div>

          <div className="symptom-item">
            <span>✓</span>
            <p>Increasing the TV or phone volume</p>
          </div>

          <div className="symptom-item">
            <span>✓</span>
            <p>Difficulty hearing in crowded environments</p>
          </div>

          <div className="symptom-item">
            <span>✓</span>
            <p>Missing parts of important conversations</p>
          </div>

          <div className="symptom-item">
            <span>✓</span>
            <p>Ringing or buzzing in your ears</p>
          </div>

          <div className="symptom-item">
            <span>✓</span>
            <p>Trouble understanding speech over phone calls</p>
          </div>

          <div className="symptom-item">
            <span>✓</span>
            <p>Feeling socially isolated due to hearing difficulties</p>
          </div>

        </div>

      </section>


      {/* ================= Quote ================= */}

      <section className="hearing-quote">

        <div className="quote-box">

          <h2>Better Hearing. Better Living.</h2>

          <p>
            Hearing connects us with conversations, music, nature,
            and the people we love. Protect your hearing and seek
            professional care whenever needed.
          </p>

        </div>

      </section>


    </>
  );
}

export default Hearing;